module.exports = __webpack_public_path__ + "src/styles/fonts/Montserrat-Medium.ttf";